import { Locale } from '@yi/core';

import { TRIAL_DAYS } from './constants';

export function getTodayDate(): Date {
  return new Date();
}

const nth = function (d: number): string {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

const getMonthName = (date: string | Date) => {
  return new Date(date).toLocaleString('en', { month: 'long' });
};

function formatENDateNth(dateArg: string | Date, excludeYear = false): string {
  const date = new Date(dateArg);
  const month = getMonthName(date);
  const year = date.getFullYear();
  const day = date.getDate();

  let formattedDate = `${month} ${day}${nth(day)}, ${year}`;
  if (excludeYear) formattedDate = `${month} ${day}${nth(day)}`;

  return formattedDate;
}

export function formatDate(
  dateArg: string | Date,
  locale: Locale,
  excludeYear?: boolean,
  formatType = 'long',
): string {
  if (formatType === 'long') {
    if (locale === 'en') {
      return formatENDateNth(dateArg, excludeYear);
    } else {
      return new Date(dateArg).toLocaleString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    }
  }
  return new Date(dateArg).toLocaleDateString('en');
}

export function getTrialStartDate(): Date {
  return getTodayDate();
}

const oneDayInMs = 1000 * 60 * 60 * 24;
export function getFirstBillingDate() {
  const trialStartDay = getTrialStartDate();
  return new Date(trialStartDay.getTime() + TRIAL_DAYS * oneDayInMs);
}

export function getFinalTrialDayDate() {
  const trialStartDay = getTrialStartDate();
  return new Date(trialStartDay.getTime() + (TRIAL_DAYS - 1) * oneDayInMs);
}
